@if (isFarmerDetailsLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <div class="animate-fade-in">
    <header class="page-header">
      <div class="header-left">
        <button class="back-btn" (click)="onBackToFarmers()" title="Back to Products">
          <i class="bi bi-arrow-left"></i>
        </button>
        <div class="header-titles">
          <h1 class="product-name">Farmer Details</h1>
          <span class="product-category">{{ farmer.full_name }}</span>
        </div>
      </div>
    </header>

    <div class="row">
      <div class="col-12 px-1">
        <div class="row mt-3 mb-4">
          <div class="col-12 col-md-6">
            <div class="card p-0 border-1 shadow-sm">
              <div class="card-body p-4">
                <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Basic Information</h6>

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Full Name</label>
                    <div class="fw-bold">{{ farmer.full_name | titlecase }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Mobile</label>
                    <div class="fw-bold">{{ farmer.mobile_number }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">WhatsApp</label>
                    <div class="fw-bold">{{ farmer.whatsapp_number }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Village</label>
                    <div class="fw-bold">{{ farmer.vilage }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Taluka</label>
                    <div class="fw-bold">{{ farmer.taluka }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">District</label>
                    <div class="fw-bold">{{ farmer.district }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">State</label>
                    <div class="fw-bold">{{ farmer.state }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Pincode</label>
                    <div class="fw-bold">{{ farmer.pincode }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Land Size</label>
                    <div class="fw-bold">{{ farmer.land_size }} acres</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Associated Employee</label>
                    <div class="fw-bold">{{ farmer.employee.full_name | titlecase }}</div>
                  </div>
                  <div class="col-12">
                    <label class="small text-muted mb-1">Crops Grown</label>
                    <div class="fw-bold">{{ farmer.crops_grown.join(', ') | titlecase }}</div>
                  </div>
                  <div class="col-12">
                    <label class="small text-muted mb-1">Associated Dealer</label>
                    <div class="fw-bold text-primary">
                      {{
                        farmer.dealer
                          ? farmer.dealer.shop_name + ' - ' + farmer.dealer.first_name + ' ' + farmer.dealer.last_name
                          : '-'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="card p-0 border-1 shadow-sm">
              <div class="card-body p-4">
                <h6 class="text-uppercase fw-bold text-muted small mb-1 letter-spacing-1">Products Used</h6>
                <p class="text-muted extra-small mb-3">Enjochem products applied or purchased</p>

                @if (farmer.products_used.length === 0) {
                  <div class="text-center py-4 bg-light border border-dashed rounded">
                    <p class="text-muted small mb-0">No Enjochem products used yet.</p>
                  </div>
                } @else {
                  <div class="list-group list-group-flush border rounded overflow-hidden">
                    <div
                      *ngFor="let product of farmer.products_used"
                      class="list-group-item px-3 py-2 border-0 border-bottom last-border-0">
                      <div class="d-flex align-items-center">
                        <div class="bg-primary bg-opacity-10 p-2 rounded text-primary me-3">
                          <i class="bi bi-box-seam fs-5"></i>
                        </div>
                        <div>
                          <h6 class="mb-0 fw-bold">{{ product.name }}</h6>
                          <div class="d-flex gap-2 align-items-center">
                            <span class="text-muted extra-small">{{ product.product_category?.name }}</span>
                            <span class="text-muted extra-small">•</span>
                            <span class="text-muted extra-small">{{ product.contents }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-4">
            <div class="card p-0 border-1 shadow-sm">
              <div class="card-body p-0">
                <div class="p-4 border-bottom">
                  <h6 class="text-uppercase fw-bold text-muted small mb-0 letter-spacing-1">Farmer Visits</h6>
                </div>

                <div class="p-4" *ngIf="farmerVisits && farmerVisits.length > 0; else noVisits">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="bg-light">
                        <tr>
                          <th class="border-0 text-uppercase small fw-bold text-muted py-3">Date</th>
                          <th class="border-0 text-uppercase small fw-bold text-muted py-3">Purpose</th>
                          <th class="border-0 text-uppercase small fw-bold text-muted py-3">Notes</th>
                          <th class="border-0 text-uppercase small fw-bold text-muted py-3">Product Recommended</th>
                          <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let visit of farmerVisits">
                          <td class="py-3 fw-medium">{{ visit.created_at | date: 'mediumDate' }}</td>
                          <td class="py-3 small">{{ visit.purpose_of_visit }}</td>
                          <td class="py-3 small text-muted text-truncate" style="max-width: 200px">
                            {{ visit.visit_notes }}
                          </td>
                          <td class="py-3">
                            <span class="badge bg-light text-dark border fw-medium small">
                              {{
                                visit.products_recommended.length ? getProductNames(visit.products_recommended) : '-'
                              }}
                            </span>
                          </td>
                          <td class="py-3 text-center">
                            <button class="btn btn-sm btn-action-info" (click)="viewVisit(visit)">
                              <i class="bi bi-eye me-1"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="mt-4">
                    <app-pagination
                      [currentPage]="currentPage"
                      [totalCount]="totalCount"
                      [pageSize]="10"
                      [hasNextPage]="hasNextPage"
                      [hasPreviousPage]="hasPreviousPage"
                      (pageChange)="onPageChange($event)"></app-pagination>
                  </div>
                </div>

                <!-- Fallback message -->
                <ng-template #noVisits>
                  <div class="text-center text-muted py-5">
                    <i class="bi bi-calendar-x fs-2 mb-2 d-block opacity-50"></i>
                    <p class="mb-0">No farmer visits found.</p>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #farmerVisit let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ selectedFarmerVisit.farmer.full_name }} - Visit Details</h5>
    <button type="button" class="btn-close" (click)="modelRef.dismiss()"></button>
  </div>

  <div class="modal-body">
    <!-- Visit date leads the modal -->
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 border-bottom pb-3 mb-3">
      <div class="d-flex align-items-center gap-3">
        <div class="text-center border bg-light px-3 py-2" style="min-width: 62px">
          <div class="fw-bold text-dark lh-1" style="font-size: 1.15rem">
            {{ selectedFarmerVisit.created_at | date: 'dd' }}
          </div>
          <div class="text-uppercase text-muted" style="font-size: 0.7rem">
            {{ selectedFarmerVisit.created_at | date: 'MMM yyyy' }}
          </div>
        </div>
        <div>
          <div class="fw-bold text-dark">{{ selectedFarmerVisit.created_at | date: 'EEEE, dd MMM yyyy' }}</div>
          <div class="small text-muted">
            <i class="bi bi-clock me-1"></i>
            {{ selectedFarmerVisit.created_at | date: 'h:mm a' }}
          </div>
        </div>
      </div>

      @if (selectedFarmerVisit.purpose_of_visit) {
        <span class="app-badge badge-soft-primary">{{ selectedFarmerVisit.purpose_of_visit }}</span>
      }
    </div>

    <div class="row g-3">
      <!-- Visited by -->
      <div class="col-12 col-md-4">
        <span class="text-uppercase small fw-bold text-muted">Visited By</span>
        <div class="d-flex align-items-center gap-2 mt-1">
          <i class="bi bi-person-badge text-primary fs-5"></i>
          <div>
            <div class="fw-semibold text-dark">{{ selectedFarmerVisit.employee.full_name }}</div>
            <div class="small text-muted">
              {{ selectedFarmerVisit.employee.employee?.designation?.title || 'Employee' }}
              @if (selectedFarmerVisit.employee.phone_number) {
                &middot; {{ selectedFarmerVisit.employee.phone_number }}
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Purpose -->
      <div class="col-12 col-md-3">
        <span class="text-uppercase small fw-bold text-muted">Purpose</span>
        <div class="mt-1 text-dark">{{ selectedFarmerVisit.purpose_of_visit || '-' }}</div>
      </div>

      <!-- Crops discussed -->
      <div class="col-12 col-md-5">
        <span class="text-uppercase small fw-bold text-muted">Crops Discussed</span>
        <div class="mt-1 d-flex flex-wrap gap-1">
          @if (selectedFarmerVisit.crops.length > 0) {
            @for (crop of selectedFarmerVisit.crops; track crop) {
              <span class="app-badge badge-soft-success">{{ crop }}</span>
            }
          } @else {
            <span class="text-muted">-</span>
          }
        </div>
      </div>

      <!-- Products recommended -->
      <div class="col-12 col-md-6">
        <span class="text-uppercase small fw-bold text-muted">Products Recommended</span>
        @if (selectedFarmerVisit.products_recommended.length > 0) {
          <ul class="list-unstyled mt-1 mb-0">
            @for (product of selectedFarmerVisit.products_recommended; track product.id) {
              <li class="d-flex align-items-start gap-2 py-2 border-bottom">
                <i class="bi bi-box-seam text-primary mt-1"></i>
                <div>
                  <span class="fw-semibold">{{ product.name }}</span>
                  @if (product.product_category) {
                    <span class="app-badge badge-secondary ms-2">{{ product.product_category.name }}</span>
                  }
                  @if (product.contents) {
                    <div class="small text-muted">{{ product.contents }}</div>
                  }
                  @if (product.company) {
                    <div class="small text-muted">{{ product.company.name }}</div>
                  }
                </div>
              </li>
            }
          </ul>
        } @else {
          <p class="text-muted mt-1 mb-0">None recommended on this visit</p>
        }
      </div>

      <!-- Notes -->
      <div class="col-12 col-md-6">
        <span class="text-uppercase small fw-bold text-muted">Visit Notes</span>
        @if (selectedFarmerVisit.visit_notes) {
          <p class="mt-1 mb-0">{{ selectedFarmerVisit.visit_notes }}</p>
        } @else {
          <p class="text-muted mt-1 mb-0">No notes recorded</p>
        }
      </div>

      <!-- Images -->
      <div class="col-12">
        <span class="text-uppercase small fw-bold text-muted">
          Images
          @if (selectedFarmerVisit.images.length > 0) {
            ({{ selectedFarmerVisit.images.length }})
          }
        </span>
        @if (selectedFarmerVisit.images.length > 0) {
          <div class="d-flex flex-wrap gap-2 mt-2">
            @for (img of selectedFarmerVisit.images; track img) {
              <img
                [src]="img"
                alt="Visit image"
                class="rounded border object-fit-cover"
                style="width: 150px; height: 150px; cursor: pointer"
                (click)="openImage(img)" />
            }
          </div>
        } @else {
          <p class="text-muted mt-1 mb-0">No images uploaded</p>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>
